import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'mlp-ng-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class JumbotronSharedComponent {
}
